<template>
    <section v-if="hasPermissions(['Budgeting-Staffing-Scenario Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <form @submit.prevent="form_submit_update(single_object.id, global_index)">
            <div class="row m-0 formdynamic" :style="'padding-top:0px;'">
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Scenario:" class="modal-label active">Scenario:  <b style="color:red;">*</b></label>
                        <input required type="text" v-model="single_object.scenario"/>
                    </div>
                </div>

                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="FTE Hours:" class="modal-label active">FTE hours per week: <b style="color:red;">*</b></label>
                        <input  step="any" required type="number" v-model="single_object.fte_hours"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Budgeted FTEs" class="modal-label active">Budgeted FTEs</label>
                        <input  step="any" type="number" v-model="single_object.budgeted_ftes"/>
                    </div>
                </div>

                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Created On:" class="modal-label active">Created  On: <b style="color:red;">*</b></label>
                        <input  disabled required type="date" v-model="single_object.date"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Benefits (%)" class="modal-label active">Benefits (%)  <b style="color:red;">*</b></label>
                        <input  step="any" required type="number" v-model="single_object.benefits"/>
                    </div>
                </div>
                
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Nonproductive (%)" class="modal-label active">Nonproductive (%) </label>
                        <input  step="any" type="number" v-model="single_object.nonproductive"/>
                    </div>
                </div>

                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Last Modified" class="modal-label active">Last Modified </label>
                        <input  disabled type="date" v-model="single_object.updated_date"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Paid Break Minutes" class="modal-label active">Paid Break Minutes </label>
                        <input  step="any" type="number" v-model="single_object.paid_break_minutes"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Management Team" class="modal-label active">Management Team </label>
                        <input  step="any" type="number" v-model="single_object.management_team"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-3">
                    <div class="formdynamic__item__field">
                        <label for="Average Wage" class="modal-label active">Average Wage </label>
                        <input  step="any" type="number" v-model="single_object.average_wage"/>
                    </div>
                </div>
                        
                <div class="py-0 formdynamic__item col-md-4">
                    <div class="formdynamic__item__field">
                        <label for="Total Salary Compensation" class="modal-label active">Total Salary Compensation </label>
                        <input disabled step="any" type="text" v-model="single_object.total_salary"/>
                    </div>
                </div>
                <div class="col-md-3"></div> <!-- Permitet correcta alineación de lo súltimos tres elementos de la cuadrícula -->
            </div>

            <DischargesForm :single_object="single_object"/>

            <div class="row mb-0 mt-3">
                <div class="col-md-12">
                    <div class="card cardModuleM pb-md-0">
                        <div class="card-content pb-md-0">
                        <div class="card-title">
                            <h2 class="subtitle--1">
                                Note
                            </h2>
                        </div>
                            <textarea v-model="single_object.notes" rows="12" class="mt-3 card-content__text"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal__buttons d-md-flex justify-content-md-end">
                <button type="button" class="modal__buttons__item mr-auto ml-0 m" v-html="`Delete <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="modal_deletion(1)"/>
                <button type="button" class="modal__buttons__item cancel ml-3 mr-0" style="margin-top:0px;" data-dismiss="modal" aria-label="Close" v-html="'Cancel'" @click="cancel()"/>
                <button v-if="hasPermissions(['Budgeting-Staffing-Fixed Read', 'Budgeting-Staffing-Fixed Write'])" type="button" class="modal__buttons__item min-width" v-html="`Edit Fixed Data <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="edit_fixed()"/>
                <button v-if="hasPermissions(['Budgeting-Staffing-Variable Read', 'Budgeting-Staffing-Variable Write'])" type="button" class="modal__buttons__item min-width" v-html="`Edit Variable Data <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" @click="edit_variable()"/>
                <button class="modal__buttons__item" v-html="`Save <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`"/>
            </div>
        </form>

         <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />

        <WaitingModal/>
    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import DeletionModal    from    '@/components/DeletionModal'
import DischargesForm   from './DischargesForm';
import Resources        from    './resources'
import FormResources    from    './form_resources'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

    name: 'StaffingScenariosUpdate',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        DischargesForm,
    },

    data() {
        return {
            notyf,
            axios,
            user:               this.get_user(),
            title_page:         'Staffing Scenario Update',
            rest_api:           `staffing_scenarios/${this.$route.params.id}`,
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb_update,
            add_btn:            'Add Staffing Scenario',
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       '',
            single_object:      {},
            array_options:      {},
            discharges_format:  FormResources.discharges_format,
            date:               '',
            form_data:          FormResources.form_data,
            form_backup:        {...FormResources.form_data},
            scenario_id:        this.$route.params.id,
        }
    },

    methods: {
        cancel()
        {
            window.location.href='/budgeting-staffing-scenario'
        },

        modal_deletion(index)
        {
            this.global_index  = index
            window.$('#static-deletion').modal('show')
        },

        fill_data(data)
        {
            this.single_object = data.scenario;
            this.global_index = data.parent_id;
            this.rest_api =  `staffing_scenarios`;
        },

        trashing()
        {
            this.redirect();
        },

        redirect()
        {
            setTimeout( ()=> {
                window.location.href = '/budgeting-staffing-scenario'
            }, 1000);
        },

        edit_fixed()
        {
            window.location.href = `/budgeting-staffing-scenario/${this.scenario_id}`;
        },

        edit_variable()
        {
            window.location.href = `/budgeting-staffing-variable/${this.scenario_id}`;
        }

    },

    watch: 
    {
        async 'single_object.benefits' (val) {
            this.single_object.total_salary = this.numberStringFormat(((this.single_object.fte_hours * 52) * ((val / 100) + 1)) * this.single_object.average_wage, 1)
        },

        async 'single_object.fte_hours' (val) {
            this.single_object.total_salary = this.numberStringFormat(((val * 52) * ((this.single_object.benefits / 100) + 1)) * this.single_object.average_wage, 1)
        },

        async 'single_object.average_wage' (val) {
            this.single_object.total_salary = this.numberStringFormat(((this.single_object.fte_hours * 52) * ((this.single_object.benefits / 100) + 1)) * val, 1)
        }

    },

    async mounted() {

        this.$on('spliceObject', (res)=> {
            // this.redirect();
            this.single_object.updated_date = res.single_object.updated_date;
            this.loader(false)
        });

        if(this.hasPermissions(['Budgeting-Staffing-Scenario Read']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },
}
</script>
